import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux'
import {Head, UserCreate, UserEdit, UserPassword} from "../../components";
import Container from "@mui/material/Container";
import IconButton from "@mui/material/IconButton";
import SyncIcon from '@mui/icons-material/Sync';
import {galleryAction} from "../../actions";
import {Box, Tooltip} from "@mui/material";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import SortIcon from '@mui/icons-material/Sort';
import ReactPaginate from "react-paginate";
import Chip from "@mui/material/Chip";
import moment from 'moment-jalaali'
import MenuItem from '@mui/material/MenuItem';
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Api from "../../utils/api";
import {toast} from "react-toastify";
import {Link} from "react-router-dom";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import CreateIcon from "@mui/icons-material/Create";
const Gallery = ( props ) => {

    const { fetchEntities, entities } = props;


    const [page, setPage] = useState(1);
    const [sort_field, setSortField] = useState('id');
    const [sort_type, setSortType] = useState('desc');
    const [limit, setLimit] = useState(10);


    useEffect(() => {
        handleRequest();
    }, [sort_field, sort_type, limit, page]);


    const handleRequest = () => {
        fetchEntities({
            sort_field: sort_field,
            sort_type: sort_type,
            page: page,
            limit: limit
        })
    };

    const handleChangeStatue = (id, field) => {
        new Api().put('/galleries/' + id + '/status', {field}).then((response) => {
            if (typeof response !== "undefined") {
                if (response.status) {
                    handleRequest()
                } else {
                    toast.error(response.msg);
                }
            }
        })
    }

    const pageCount = Math.ceil(parseInt(entities.data?.total) / parseInt(entities.data?.per_page));

    return(
        <Container>
            <Head data={{ 'link': '/', 'title': 'مدیریت اسلایدر و گالری تصاویر', 'description': 'گالری تصاویر را مدیریت کنید' }} />
            <Box mb={2}>
                <Grid container alignItems="center" >
                    <Grid item xs={4} sm={6}>
                        <TextField
                            select
                            value={limit}
                            margin='dense'
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onChange={(event) => setLimit(event.target.value)}
                        >
                            <MenuItem  value="10">10</MenuItem>
                            <MenuItem  value="20">20</MenuItem>
                            <MenuItem  value="30">30</MenuItem>
                            <MenuItem  value="50">50</MenuItem>
                            <MenuItem  value="100">100</MenuItem>
                            <MenuItem  value="200">200</MenuItem>
                        </TextField>
                    </Grid>
                    <Grid item xs={8} sm={6}>
                        <ReactPaginate
                            previousLabel={'<'}
                            nextLabel={'>'}
                            breakLabel={'...'}
                            pageCount={pageCount}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={(selectedItem) => setPage(selectedItem.selected + 1)}
                            containerClassName={'pagination'}
                            activeClassName={'active'}
                        />
                    </Grid>
                </Grid>
            </Box>
            <div style={{ display: 'flex', direction: 'row', justifyContent: 'flex-end'}}>
                <Tooltip title="افزودن">
                    <Link to={'/gallery/create'}>
                        <IconButton>
                            <AddCircleOutlineIcon />
                        </IconButton>
                    </Link>
                </Tooltip>
                <Tooltip title="سینک" onClick={() => handleRequest()}>
                    <IconButton>
                        <SyncIcon />
                    </IconButton>
                </Tooltip>
            </div>
            <>
                <div style={{ overflowX: 'auto'}}>
                    <table className='table'>
                        <thead>
                        <tr>
                            <th onClick={() => { setSortField('id'); setSortType(sort_type === 'desc' ? 'asc' : 'desc') }}>#&nbsp;{ sort_field === 'id' ? (sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                            <th onClick={() => { setSortField('created_by'); setSortType(sort_type === 'desc' ? 'asc' : 'desc') }}>اپراتور&nbsp;{sort_field === 'created_by' ? (sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                            <th onClick={() => { setSortField('title'); setSortType(sort_type === 'desc' ? 'asc' : 'desc') }}>نام &nbsp;{sort_field === 'title' ? (sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                            <th onClick={() => { setSortField('created_at'); setSortType(sort_type === 'desc' ? 'asc' : 'desc') }}>تاریخ ایجاد&nbsp;{sort_field === 'created_at' ? (sort_type === 'desc'  ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />) : <SortIcon />}</th>
                            <th onClick={() => { setSortField('status'); setSortType(sort_type === 'desc' ? 'asc' : 'desc') }}>وضعیت&nbsp;{sort_field === 'status' ? (sort_type === 'desc' ? <ArrowDownwardIcon/> : <ArrowUpwardIcon/>) : <SortIcon/>}</th>
                            <th onClick={() => { setSortField('is_slider'); setSortType(sort_type === 'desc' ? 'asc' : 'desc') }}>نوع&nbsp;{sort_field === 'is_slider' ? (sort_type === 'desc' ? <ArrowDownwardIcon/> : <ArrowUpwardIcon/>) : <SortIcon/>}</th>
                            <th onClick={() => { setSortField('show_in'); setSortType(sort_type === 'desc' ? 'asc' : 'desc') }}>نمایش&nbsp;{sort_field === 'show_in' ? (sort_type === 'desc' ? <ArrowDownwardIcon/> : <ArrowUpwardIcon/>) : <SortIcon/>}</th>
                            <th>عملیات</th>
                        </tr>
                        </thead>
                        <tbody>
                        {entities.data.data && entities.data.data.map((entity, index) => {
                            return(
                                <tr key={index}>
                                    <td>{entity.id}</td>
                                    <td>{entity.created_by && entity.created_by.name}</td>
                                    <td>{entity.title}</td>
                                    <td style={{ direction: 'ltr'}}>{moment(entity.created_at, 'YYYY/MM/DD HH:mm:ss').locale('fa').format('jYYYY/jMM/jDD HH:mm:ss')}</td>
                                    <td>
                                        <Tooltip title="وضعیت">
                                            <Chip size={"small"} variant={"outlined"} color={entity.status ? "primary": "secondary"}  label={entity.status ? 'فعال' : 'غیرفعال'} clickable={true} onClick={() => handleChangeStatue(entity.id, 'status')} />
                                        </Tooltip>
                                    </td>
                                    <td>
                                        <Tooltip title="نوع">
                                            <Chip size={"small"} variant={"outlined"} color={"default"}  label={entity.is_slider ? 'اسلایدر' : 'گالری تصاویر'} clickable={true} onClick={() => handleChangeStatue(entity.id, 'is_slider')} />
                                        </Tooltip>
                                    </td>
                                    <td>
                                        {entities.show_in[entity.show_in]}
                                    </td>
                                    <td>
                                        <Tooltip title="ویرایش">
                                            <Link to={`/gallery/${entity.id}/edit`}>
                                                <IconButton>
                                                    <CreateIcon />
                                                </IconButton>
                                            </Link>
                                        </Tooltip>
                                    </td>
                                </tr>
                            );
                        })}
                        </tbody>
                    </table>
                </div>
                <ReactPaginate
                    previousLabel={'<'}
                    nextLabel={'>'}
                    breakLabel={'...'}
                    pageCount={pageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={(selectedItem) => setPage(selectedItem.selected + 1)}
                    containerClassName={'pagination'}
                    activeClassName={'active'}
                />
            </>
        </Container>

    );
}


const mapStateToProps = state => ({
    entities: state.galleryReducer,
});

const mapDispatchToProps = (dispatch) => ({
    fetchEntities: (object) => {
        dispatch(galleryAction.fetchGalleries(object))
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(Gallery)
